(exports.GAME_ID = "602549798728560015202499"),
(exports.FORM_ID = "6025497e872856001520249a"),
(exports.STATUS_ID = "604098955f01640015a8f8f1"),
(exports.SERVER_URL = "https://api.lucien.ai"),
(exports.BD_NAME = "jeu-dev");